module.exports = __webpack_public_path__ + "img/8.acd62e5f.jpg";